<unity-page-container contentHeader="Clients" [contentHeaderSecondary]="$contentHeaderSecondary()" [isLoading]="false">
  <ng-container notifications />

  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>

  <ng-container actions>
    <unity-action-shared [action]="$createClientAction()" />
  </ng-container>

  <ng-container stats>
    @let agreementStats = $agreementStats();
    @let agreement = $agreement();
    <unity-card-item-count-summary-shared
      displayName="Active Clients"
      [itemCount]="agreementStats?.total_active_clients"
      [isLoading]="agreementStatsResource.isLoading()" />
    @if (agreement?.supports_client_expenses) {
      <unity-card-budget-summary-shared [agreement]="agreementStats" [isLoading]="agreementStatsResource.isLoading()" />
    }
  </ng-container>

  <unity-grid-client-shared [agreementId]="$agreementId()" />
</unity-page-container>
